<div class="flex flex-col gap-4">
    <p-card>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Left Column -->
            <div class="flex flex-col gap-6">
                <!-- Recruiting Report -->
                <div>
                    <div class="flex items-center gap-2 mb-3">
                        <h3 class="text-lg font-semibold m-0">Recruiting Report</h3>
                        <i class="pi pi-info-circle text-sm cursor-pointer"
                            pTooltip="All trips registered between the selected dates for any trip year. Includes deactivated trips, but not trips dropped due to accidental/duplicate registration"></i>
                    </div>


                    <form [formGroup]="recruitingForm" (ngSubmit)="onSubmitRecruitingReport()"
                        class="flex flex-col gap-3">
                        <app-date-range-picker formControlName="dateRange"
                            [presets]="tripDatePresets"></app-date-range-picker>

                        <div>
                            <button pButton type="submit" label="Generate Report" class="p-button-primary"></button>
                        </div>
                    </form>
                </div>

                <!-- Trip Leading Report -->
                <div>
                    <h3 class="text-lg font-semibold mb-3">Trip Leading Report</h3>

                    <form [formGroup]="tripLeadingForm" (ngSubmit)="onSubmitTripLeadingReport()"
                        class="flex flex-col gap-3">
                        <div class="flex flex-col gap-1">
                            <label for="dateRange" class="font-medium">Select Date Range</label>
                            <app-date-range-picker formControlName="dateRange"
                                [presets]="tripDatePresets"></app-date-range-picker>

                            <div class="flex flex-col gap-1">
                                <label for="staffId" class="font-medium">
                                    Select Staff
                                </label>
                                <app-staff-dropdown formControlName="staffId" [options]="filteredStaffList()"
                                    class="w-full" [disabled]="isLoadingStaffList()"
                                    placeholder="Select a staff member">
                                </app-staff-dropdown>
                                <small *ngIf="filteredStaffList().length === 0 && !isLoadingStaffList()"
                                    class="text-gray-500">
                                    No trip leaders found for selected date range
                                </small>
                            </div>
                        </div>

                        <div>
                            <button pButton type="submit" label="Generate Report" class="p-button-primary"
                                [disabled]="isLoading() || (filteredStaffList().length === 0 && !isLoadingStaffList())"></button>
                        </div>
                    </form>
                </div>

                <!-- Trip Leading Dates Spreadsheet -->
                <div>
                    <h3 class="text-lg font-semibold mb-3">Trip Leading Dates Report</h3>

                    <form [formGroup]="tripLeadingDatesForm" (ngSubmit)="onSubmitTripLeadingDatesReport()"
                        appendTo="body" class="flex flex-col gap-3">

                        <app-date-range-picker formControlName="dateRange"
                            [presets]="tripDatePresets"></app-date-range-picker>

                        <div>
                            <button pButton type="submit" label="Generate Report" class="p-button-primary"
                                [disabled]="isLoading()"></button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="flex flex-col gap-6">
                <!-- Web Lead Report -->
                <div *ngIf="isSalesAdmin" >
                    <h3 class="text-lg font-semibold mb-3">Web Lead Report</h3>

                    <form [formGroup]="webLeadForm" (ngSubmit)="onSubmitWebLeadReport()" class="flex flex-col gap-3">
                        <app-date-range-picker formControlName="dateRange"
                            [presets]="tripDatePresets"></app-date-range-picker>

                        <div>
                            <button pButton type="submit" label="Generate Report" class="p-button-primary"
                                [disabled]="isLoading()"></button>
                        </div>
                    </form>
                </div>

                <!-- Trip Payment Report -->
                <div>
                    <h3 class="text-lg font-semibold mb-3">Trip Payment Report</h3>

                    <form [formGroup]="tripPaymentForm" (ngSubmit)="onSubmitTripPaymentReport()"
                        class="flex flex-col gap-3">
                        <app-date-range-picker formControlName="dateRange"
                            [presets]="tripDatePresets"></app-date-range-picker>

                        <div>
                            <button pButton type="submit" label="Generate Report" class="p-button-primary"
                                [disabled]="isLoading()"></button>
                        </div>
                    </form>
                </div>

                <div>
                    <h3 class="text-lg font-semibold mb-3">Calls Report</h3>

                    <form [formGroup]="callReportForm" (ngSubmit)="onSubmitCallReport()" class="flex flex-col gap-3">
                        <app-date-range-picker formControlName="dateRange"
                            [presets]="tripDatePresets"></app-date-range-picker>

                        <div class="flex flex-col gap-1">
                            <label for="callType" class="font-medium">Call Types</label>

                            <p-select formControlName="callType" [options]="callTypesOptions"
                                class="align-self-stretch w-full" appendTo="body"></p-select>
                        </div>

                        <div>
                            <button pButton type="submit" label="Generate Report" class="p-button-primary"
                                [disabled]="isLoading()">
                            </button>

                        </div>
                    </form>
                </div>

            </div>
        </div>

    </p-card>

    @if(isLoading()) {
    <app-table-skeleton [rowCount]="10" [columnCount]="9"></app-table-skeleton>
    } @else if (hasAnyData()) {

    <!-- Recruiting Trip Report -->

    @if(recruitingTripReport().length > 0) {
    <p-card class="mb-4">

        <p-table #atlsDetailsTable dataKey="id" [value]="recruitingTripReport()" [resizableColumns]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['groupname', 'location', 'glName', 'attendees', 'cost', 'tlName', 'tripID', 'custId']"
            [scrollable]="true" exportFilename="Recruiting Reports" styleClass="p-datatable-gridlines"
            [tableStyle]="{'min-width': '120rem'}" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20, 50]"
            [columns]="recruitingTripReportColumns()">

            <ng-template #caption>
                <div class="flex justify-between items-center">
                    <h3 class="m-0">Recruiting Trip Report Data({{ recruitingTripReport().length }} total)</h3>
                    <app-table-caption [table]="atlsDetailsTable" [showClearFilters]="true"></app-table-caption>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <app-table-headers [columns]="recruitingTripReportColumns()"></app-table-headers>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr>
                    <app-table-columns [columns]="recruitingTripReportColumns()" [data]="item"></app-table-columns>
                </tr>
            </ng-template>
        </p-table>

    </p-card>
    }

    <!-- Trip Leader Details Report -->
    @if(tripLeaderDetails().length > 0) {
    <p-card class="mb-4">

        <p-table #tripLeaderDetailsTable dataKey="id" [value]="tripLeaderDetails()" [resizableColumns]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['groupname', 'destination', 'leader', 'attendees']" [scrollable]="true"
            exportFilename="Trip Leader Details Reports" styleClass="p-datatable-gridlines"
            [tableStyle]="{'min-width': '120rem'}" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20, 50]"
            [columns]="tripLeaderReportColumns()">

            <ng-template #caption>
                <div class="flex justify-between items-center">
                    <h3 class="m-0">Trip Leader Details Report Data ({{ tripLeaderDetails().length }} total)</h3>
                    <app-table-caption [table]="tripLeaderDetailsTable" [showClearFilters]="true"></app-table-caption>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <app-table-headers [columns]="tripLeaderReportColumns()"></app-table-headers>

                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr>
                    <app-table-columns [columns]="tripLeaderReportColumns()" [data]="item"></app-table-columns>
                </tr>
            </ng-template>
        </p-table>

    </p-card>
    }

    <!-- ATL Details Report -->
    @if(atlDetails().length > 0) {
    <p-card class="mb-4">

        <p-table #atlsDetailsTable dataKey="id" [value]="atlDetails()" [resizableColumns]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['groupname', 'destination', 'leader', 'attendees']" [scrollable]="true"
            exportFilename="ATL Details Reports" styleClass="p-datatable-gridlines"
            [tableStyle]="{'min-width': '120rem'}" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20, 50]"
            [columns]="tripLeaderReportColumns()">

            <ng-template #caption>
                <div class="flex justify-between items-center">
                    <h3 class="m-0">ATL Details Report Data ({{ atlDetails().length }} total)</h3>
                    <app-table-caption [table]="atlsDetailsTable" [showClearFilters]="true"></app-table-caption>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <app-table-headers [columns]="tripLeaderReportColumns()"></app-table-headers>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr>
                    <app-table-columns [columns]="tripLeaderReportColumns()" [data]="item"></app-table-columns>
                </tr>
            </ng-template>
        </p-table>

    </p-card>
    }

    <!-- Trip Leading Dates Report -->

    @if(tripList().length > 0) {
    <p-card class="mb-4">

        <p-table #tripLeadingDates dataKey="id" [value]="tripList()" [resizableColumns]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['staffName', 'tripStartDate', 'tripEndDate', 'duration']" [scrollable]="true"
            exportFilename="Trip List Reports" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '120rem'}"
            [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20, 50]" [columns]="tripListColumn()">

            <ng-template #caption>
                <div class="flex justify-between items-center">
                    <h3 class="m-0">Trip List Report ({{ tripListSummary().length }} total)</h3>
                    <app-table-caption [table]="tripLeadingDates" [showClearFilters]="true"></app-table-caption>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>

                    <app-table-headers [columns]="tripListColumn()"></app-table-headers>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr>

                    <app-table-columns [columns]="tripListColumn()" [data]="item"></app-table-columns>
                </tr>
            </ng-template>
        </p-table>

        <p-table #tripListSummaryTable dataKey="id" [value]="tripListSummary()" [resizableColumns]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['staffName', 'days']" [scrollable]="true" exportFilename="Trip List Summary Reports"
            styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '120rem'}" [paginator]="true" [rows]="10"
            [rowsPerPageOptions]="[5, 10, 20, 50]" [columns]="tripListSummaryColumns()">

            <ng-template #caption>
                <div class="flex justify-between items-center">
                    <h3 class="m-0">Trip List Summary ({{ tripListSummary().length }} total)</h3>
                    <app-table-caption [table]="tripListSummaryTable" [showClearFilters]="true"></app-table-caption>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>

                    <app-table-headers [columns]="tripListSummaryColumns()"></app-table-headers>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr>

                    <app-table-columns [columns]="tripListSummaryColumns()" [data]="item"></app-table-columns>
                </tr>
            </ng-template>

        </p-table>

    </p-card>
    }

    <!-- New Lead Report -->

    @if(newLeads().length > 0) {
    <p-card class="mb-4">

        <p-table #newLeadsTable dataKey="id" [value]="newLeads()" [resizableColumns]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['name', 'org', 'location', 'recruiter', 'email', 'size']" [scrollable]="true"
            exportFilename="New Leads Reports" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '120rem'}"
            [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20, 50]" [columns]="newLeadColumns()">

            <ng-template #caption>
                <div class="flex justify-between items-center">
                    <h3 class="m-0">New Lead Report Data ({{ newLeads().length }} total)</h3>
                    <app-table-caption [table]="newLeadsTable" [showClearFilters]="true"></app-table-caption>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <app-table-headers [columns]="newLeadColumns()"></app-table-headers>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr>
                    <app-table-columns [columns]="newLeadColumns()" [data]="item"></app-table-columns>
                </tr>
            </ng-template>
        </p-table>

    </p-card>
    }

    @if(paymentReports().length > 0) {
    <p-card class="mb-4">

        <p-table #paymentReportsTable dataKey="id" [value]="paymentReports()" [resizableColumns]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['tripId', 'recruiterName', 'groupname', 'location', 'consultantName', 'tlName', 'paymentType', 'cost' ]"
            [scrollable]="true" exportFilename="Payment Reports" styleClass="p-datatable-gridlines"
            [tableStyle]="{'min-width': '120rem'}" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20, 50]"
            [columns]="paymentReportColumns()">

            <ng-template #caption>
                <div class="flex justify-between items-center">
                    <h3 class="m-0">Payment Report Data ({{ paymentReports().length }} total)</h3>
                    <app-table-caption [table]="paymentReportsTable" [showClearFilters]="true"></app-table-caption>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <app-table-headers [columns]="paymentReportColumns()"></app-table-headers>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr>
                    <app-table-columns [columns]="paymentReportColumns()" [data]="item"></app-table-columns>
                </tr>
            </ng-template>
        </p-table>

    </p-card>
    }

    @if(callReportData().length > 0) {
    <p-card class="mb-4">

        <p-table #callReportsTable dataKey="id" [value]="callReportData()" [resizableColumns]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['name', 'org', 'location', 'recruiter', 'email', 'size']" [scrollable]="true"
            exportFilename="Call Reports" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '120rem'}"
            [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20, 50]" [columns]="callReportColumns()">

            <ng-template #caption>
                <div class="flex justify-between items-center">
                    <h3 class="m-0">Call Report Data ({{ callReportData().length }} total)</h3>
                    <app-table-caption [table]="callReportsTable" [showClearFilters]="true"></app-table-caption>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <app-table-headers [columns]="callReportColumns()"></app-table-headers>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr>
                    <app-table-columns [columns]="callReportColumns()" [data]="item"></app-table-columns>
                </tr>
            </ng-template>
        </p-table>

        <p>Call Report Totals: {{ callReportTotals().total }}</p>

    </p-card>
    }

    } @else if (hasSearched()) {
    <p-card>
        <div class="text-center p-8">
            <i class="pi pi-search text-5xl mb-4 text-gray-300"></i>
            <h3 class="text-lg font-semibold mb-2">No Results Found</h3>
            <p class="text-gray-500">Try adjusting your search criteria and search again.</p>
        </div>
    </p-card>
    }

</div>